<template>
  <div></div>
</template>

<script>
import fileDownload from "js-file-download";
export default {
  name: "ManualPdf",
  data() {
    return {
      fileName: "",
      userId: "",
      userClas: "",
      filelinkUrl: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let params = {
        userClass: this.$store.getters.getUserClass,
        buildGroupId: this.$store.getters.getBuilGroupId,
        buildId: this.$store.getters.getBuilId,
      };
      //ログインユーザのマニュアルのPDFを取得する
      this.getRequest(
        "/userManual/manualGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        //ファイルパスは戻り
        if (data.success) {
          let streamParams = {
            filePath: data.result,
          };
          //PDFはダウンロード
          this.getStreamRequest(
            "/userManual/pdfGet",
            streamParams,
            this.$store.getters.getUserToken
          )
            .then((res) => {
              const blob = new Blob([res], {
                type: "application/octet-stream;charset=utf-8",
              });
              return fileDownload(blob, "ユーザマニュアル.pdf");
            })
            .catch(function (error) {
              // console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style></style>
